module.exports = __webpack_public_path__ + "img/email.a5db431f.png";